import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('ProfitCenter?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('ProfitCenter/show/'+id);
    },    
    create(params) {
        return Service().post('ProfitCenter/create', params);
    },
    update(id, params) {
        return Service().post('ProfitCenter/update/'+id, params);
    },
    delete(id) {
        return Service().post('ProfitCenter/delete/'+id);
    }
}